import { render } from "./SaveRecordingForm.vue?vue&type=template&id=65f30499"
import script from "./SaveRecordingForm.vue?vue&type=script&lang=js"
export * from "./SaveRecordingForm.vue?vue&type=script&lang=js"

import "./SaveRecordingForm.vue?vue&type=style&index=0&id=65f30499&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__